<template>
  <v-container fluid ma-0 pa-0 px-4 id="bucketnew-main">
    <Loading :isLoading="loading">
      <div
        class="fixed-header"
        :class="{ mobile: $vuetify.breakpoint.smAndDown }"
      >
        <!-- if has summary fields add class 'with-summary' -->
        <v-layout align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate">
                  {{ bucketGroupName }}
                </h2>
              </template>
              <span>{{ bucketGroupName }}</span>
            </v-tooltip>
            <h4 class="pt-1 sub-header d-inline-block">
              Buckets -
              <span class="font-weight-bold">{{ buckets.length }}</span>
            </h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
              <v-btn
                icon
                flat
                slot="activator"
                :to="{ path: bucketCreateRoute(this.caseTypeId) }"
              >
                <v-icon color="success" size="24">add_circle</v-icon>
              </v-btn>
              <span>Create a new bucket</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </div>

      <v-layout wrap>
        <v-flex xs12>
          <v-btn
            :ripple="false"
            flat
            class="ml-0 mb-2 search-button"
            v-on:click="bucketsToggled = !bucketsToggled"
          >
            <v-icon color="secondary" class="mr-2 mt-0">{{
              bucketsToggled ? "close" : "search"
            }}</v-icon>
            {{ bucketsToggled ? "Close search" : "Search" }}
          </v-btn>
          <v-slide-y-transition>
            <v-layout row wrap class="mt-0" v-if="bucketsToggled">
              <v-flex
                xs12
                sm6
                md4
                pt-1
                :class="{
                  'pr-0 ': $vuetify.breakpoint.xsAndDown,
                  'pr-2': $vuetify.breakpoint.smAndUp,
                }"
              >
                <v-text-field
                  box
                  class="cardcontainer-search-text pa-0 ma-0 body-1"
                  v-model="searchTerm"
                  label="Search"
                  clearable
                  color="secondary"
                  clear-icon="cancel"
                >
                  <template slot="append">
                    <v-icon>search</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                pt-1
                :class="{
                  'pl-0': $vuetify.breakpoint.xsAndDown,
                  'pl-2': $vuetify.breakpoint.smAndUp,
                }"
              >
                <v-select
                  box
                  style="border-bottom: 0 !important"
                  class="cardcontainer-order-select pa-0 ma-0 body-1"
                  :items="sortableBy"
                  v-model="orderSelection"
                  label="Order by"
                  clearable
                  color="secondary"
                  clear-icon="cancel"
                  append-icon="keyboard_arrow_down"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
      <v-layout mt-1 row wrap fluid>
        <BucketTile
          :bucket="bucket"
          v-for="(bucket, i) in this.buckets"
          :permissions="permissions"
          :show-statistics="true"
          :key="bKey(i)"
        ></BucketTile>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Loading from "@/components/shared/Loading.vue";
import BucketTile from "@/components/buckets/bucket-elements/BucketTile";

export default {
  name: "CaseTemplateOverview",
  components: {
    Loading,
    BucketTile,
  },
  props: {},
  data: () => ({
    loading: false,
    bucketsToggled: false,
  }),
  computed: {
    ...mapState({
      caseTypes: (state) => state.caseTypes.all,
      permissions: (state) => state.ui.grantedPermissions,
    }),
    caseTypeId() {
      return parseInt(this.$route.params.case_type_id);
    },
    bucketGroupId() {
      return parseInt(this.$route.params.bucket_group_id);
    },
    bucketGroup() {
      if (!this.caseTypes || isNaN(this.caseTypeId) || isNaN(this.bucketGroupId)) {
        return undefined;
      }
      const caseType = this.caseTypes.find((ct) => ct.id === this.caseTypeId);
      if (!caseType || !caseType.bucketGroups) {
        return undefined;
      }
      return caseType.bucketGroups.find((bg) => bg.id === this.bucketGroupId);
    },
    bucketGroupName() {
      return (this.bucketGroup && this.bucketGroup.name) || "";
    },
    buckets() {
      if (this.bucketGroup && this.bucketGroup.buckets) {
        return this.bucketGroup.buckets;
      }
      return [];
    },
  },
  methods: {
    bKey: (i) => `b-${i}`,
    bgKey: (i) => `bg-${i}`,
    bucketCreateRoute: (caseTypeId) => `/case-types/${caseTypeId}/buckets/new`,
  },
};
</script>
